import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import ModalContainer from "../../modal/ModalContainer";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { Button, Grid, Card, Switch, Avatar, Typography } from "@material-ui/core";

import CardHeader from "@material-ui/core/CardHeader";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import image from "../../../helper/image";

@inject("agentVenueStore", "templateStore")
@observer
class EditAgentModal extends Component {
    state = { isSaving: false };

    handleClose = () => {
        if (!this.state.isSaving) this.props.onClose();
    };

    renderDaySwitch = () => {
        const { editedAgentVenue } = this.props.agentVenueStore;

        return (
            <Grid container spacing={8}>
                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(data => (
                    <Grid item xs={6} key={data}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={!!(editedAgentVenue && editedAgentVenue[data.toLowerCase()])}
                                    disabled={this.state.isSaving}
                                    onChange={() => this.props.agentVenueStore.toggleEditedAgentVenueBooking(data.toLowerCase())}
                                    value={data.toLowerCase()}
                                    color="primary"
                                />
                            }
                            label={data}
                        />
                    </Grid>
                ))}
            </Grid>
        );
    };

    handleSubmitEdit = async () => {
        const { editedAgentVenue } = this.props.agentVenueStore;
        if (!editedAgentVenue || this.state.isSaving) return;
        this.setState({ isSaving: true });
        this.props.templateStore.showLoadingScreen();
        try {
            await this.props.agentVenueStore.submit([editedAgentVenue]);
            this.props.templateStore.closeRegionBlock();
            this.props.onClose();
        } catch (error) {
            this.props.templateStore.openSnackbar("Unable to save booking days. Please try again.");
        } finally {
            this.props.templateStore.hideLoadingScreen();
            this.setState({ isSaving: false });
        }
    };

    render() {
        const { editedAgentVenue } = this.props.agentVenueStore;
        const { venueContext } = this.props;
        const profile = editedAgentVenue && (venueContext ? editedAgentVenue.venue : editedAgentVenue.agent);
        const profileName = profile && (profile.fullName || profile.profileName);

        return (
            <ModalContainer open={this.props.open} onClose={this.handleClose} title={venueContext ? "Edit Venue Booking Days" : "Edit Agent Booking Days"} maxWidth="sm">
                <DialogContent>
                    <Typography variant="caption">{venueContext
                        ? "Select the days of the week you would like to book this venue."
                        : "Select the days of the week you would like this agent to book this venue."}</Typography>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            {profile ? (
                                <Card>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                alt={profileName}
                                                src={image.getProfileImage(profile)}
                                                style={{
                                                    width: 40,
                                                    height: 40
                                                }}
                                            />
                                        }
                                        title={profileName}
                                    />
                                </Card>
                            ) : (
                                ""
                            )}
                        </Grid>
                    </Grid>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            {this.renderDaySwitch()}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} disabled={this.state.isSaving}>Close</Button>
                    <Button color="primary" onClick={this.handleSubmitEdit} disabled={this.state.isSaving || !editedAgentVenue}>
                        Save
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default EditAgentModal;
